<div class="ws-filter-container">
    <div class="ws-flex-container-horizontal ws-stretch-width">
        <select class="form-select form-select-sm"
                [ngModel]="filterValues[0].filterType"
                (ngModelChange)="setFilterType($event, 0)">
            @for (option of selectFilterOptions; track option) {
                <option [ngValue]="option">{{ option.displayName }}</option>
            }
        </select>
        <div class="condition ws-flex-container-horizontal">
            <button class="ace-btn btn-sm btn-secondary"
                    [class.active]="filterConditionType === 1"
                    (click)="setConditionType(1)">And
            </button>
            <button class="ace-btn btn-sm btn-secondary"
                    [class.active]="filterConditionType === 2"
                    (click)="setConditionType(2)">Or
            </button>
        </div>
    </div>
    @for (filter of filterValues; track trackByFn(i); let isFirst = $first; let isLast = $last; let i = $index) {
        @if (filterConditionType !== 0 && !isFirst) {
            <div class="condition-filter-type ws-flex-container-horizontal">
                <select class="form-select form-select-sm"
                        [ngModel]="filter.filterType"
                        (ngModelChange)="setFilterType($event, i)">
                    @for (option of selectFilterOptions; track option) {
                        <option [ngValue]="option">{{ option.displayName }}</option>
                    }
                </select>
                <button class="ace-btn has-icon btn-primary btn-danger btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.removeFilter"
                        position="right"
                        (click)="removeFilterValue(i)">
                    <i class="fa fa-minus"></i>
                </button>
                @if (filter.filterType && !filter.filterType.numberOfInputs) {
                    <button
                        class="ace-btn has-icon btn-primary btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.addFilter"
                        position="right"
                        (click)="addFilterValue()">
                        <i class="fa fa-plus"></i>
                    </button>
                }
            </div>
        }
        @if (!(filter.filterType && !filter.filterType.numberOfInputs)) {
            <div class="ws-flex-container-horizontal">
                <div class="text-input ws-flex-container-horizontal">
                    <input #input
                           [numbersOnly]="filter.filterType?.displayKey !== 'Comma Separated'"
                           type="text"
                           [placeholder]="((filter.filterType && filter.filterType.displayKey === 'inRange') ? 'From...' : 'Filter...')"
                           (ngModelChange)="onChange($event, i)"
                           [ngModel]="filter.filterValue"
                           class="form-control mb-1"
                           (keyup.enter)="enterPressed($event, filter.filterValue)"
                           [class.has-reset]="filter.filterToValue"/>
                    <span class="reset-value clickable"
                          [class.showReset]="filter.filterValue"
                          helpTooltip
                          helpContentId="ag-grid.clearField"
                          position="right"
                          (click)="clearInput(i)">
                        <i class="fa fa-times"></i>
                    </span>
                </div>
                @if (filterConditionType !== 0 && isLast) {
                    <button
                        class="ace-btn has-icon btn-primary btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.addFilter"
                        position="right"
                        [disabled]="!filter.filterValue"
                        (click)="addFilterValue()">
                        <i class="fa fa-plus"></i>
                    </button>
                }
            </div>
        }
        @if (filter.filterType && filter.filterType.displayKey === 'inRange' && !(filter.filterType && !filter.filterType.numberOfInputs)) {
            <div
                class="text-input ws-flex-container-horizontal">
                <input #toValue
                       [numbersOnly]="true"
                       type="text"
                       placeholder="To..."
                       (ngModelChange)="onToValueChange($event, i)"
                       [ngModel]="filter.filterToValue"
                       class="form-control"
                       [class.has-reset]="filter.filterToValue"/>
                <span class="reset-value clickable"
                      [class.showReset]="filter.filterToValue"
                      helpTooltip
                      helpContentId="ag-grid.clearField"
                      position="right">
                    <i class="fa fa-times"></i>
                </span>
            </div>
        }
    }
    <div class="ws-flex-container-horizontal">
        <button #applyButton
                class="ace-btn btn-primary btn-sm ws-stretch-width"
                helpTooltip
                helpContentId="ag-grid.applyFilter"
                position="bottom"
                (click)="applyNumberFilter()">Apply
        </button>
        <button class="ace-btn has-icon btn-primary btn-danger btn-sm"
                helpTooltip
                helpContentId="ag-grid.addFilter"
                position="right"
                (click)="clearFilter()">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>
